// extracted by mini-css-extract-plugin
export default {"changeLink":"KR-z","disabled":"LR-z","inline":"MR-z"};